export const MOBILE_WINDOW_INNER_WIDTH_THRESHOLD = 768;
export function isMobile() {
    return typeof window === 'object' && window.innerWidth <= MOBILE_WINDOW_INNER_WIDTH_THRESHOLD;
}
//# sourceMappingURL=index.js.map